import FormattedMessage from 'I18n/components/FormattedMessage';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { FeatureTableTag } from 'pricing-pages-ui-components/badges/FeatureTableTag/FeatureTableTag';
import { useCardBadge } from '../../v2/hooks/badges/useCardBadge';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableColTag = ({
  apiName,
  badgeName
}) => {
  const {
    badgeName: badgeNameToShow,
    validatedBundleKey
  } = useCardBadge({
    apiName,
    badgeName
  });
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  if (badgeNameToShow === 'CURRENT_TRIAL') {
    return /*#__PURE__*/_jsx(FeatureTableTag, {
      textColor: "text-core-default",
      backgroundColor: isTrellis ? 'fill-surface-default' : 'fill-tertiary-pressed',
      borderColor: isTrellis ? 'border-core-default' : undefined,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: validatedBundleKey !== null && validatedBundleKey !== void 0 ? validatedBundleKey : `pricing-pages-ui.merchCardsV2.badges.${badgeNameToShow}`
      })
    });
  }
  if (badgeNameToShow === 'OWNED_VIA_BUNDLE') {
    return /*#__PURE__*/_jsx(FeatureTableTag, {
      textColor: isTrellis ? 'text-core-on-fill-default' : 'text-core-default',
      backgroundColor: isTrellis ? 'border-core-default' : 'fill-tertiary-pressed',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: validatedBundleKey !== null && validatedBundleKey !== void 0 ? validatedBundleKey : 'pricing-pages-ui.merchCardsV2.badges.CURRENT_PLAN'
      })
    });
  }
  if (badgeNameToShow === 'CURRENT_PLAN' || badgeNameToShow === 'LEGACY_OWNED') return /*#__PURE__*/_jsx(FeatureTableTag, {
    textColor: isTrellis ? 'text-core-on-fill-default' : 'text-core-default',
    backgroundColor: isTrellis ? 'border-core-default' : 'fill-tertiary-pressed',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.merchCardsV2.badges.${badgeNameToShow}`
    })
  });
  if (badgeNameToShow === 'RECOMMENDED' || badgeNameToShow === 'MOST_POPULAR') return /*#__PURE__*/_jsx(FeatureTableTag, {
    textColor: "text-core-on-fill-default",
    backgroundColor: isTrellis ? 'specialty-tertiary-on-fill-default' : 'fill-positive-default',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.merchCardsV2.badges.${badgeNameToShow}`
    })
  });
  return null;
};
export default FeatureTableColTag;